import { CertidaoNegativaDebitosDto } from "core/features/relatorios/typings";
import http from "infra/http";
import { useMutation } from "react-query";
import { FiltroCertidaoNegativaForm } from '../typings/index';

export default function useRelatorioCertidaoNegativaDebitos() {
  return useMutation(
    `/v1/relatorios/unidades/certidao-negativa-debitos`,
    async (filtro: FiltroCertidaoNegativaForm) => {
      const url = "/v1/relatorios/unidades/certidao-negativa-debitos";

      const { data } = await http.get<CertidaoNegativaDebitosDto>(url, {
        params: {
          ...filtro,
        },
      });

      return data;
    }
  );
}
